export default __webpack_public_path__ + "static/media/arrow-right.824607cd.svg";